const getRouterKey = userDetails => (userDetails.pmiplatform ? 'pmiRoutes' : 'rcRoutes');

export default getRouterKey;
